import { useContext, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { experimentalStyled } from '@mui/material/styles';
import toast from 'react-hot-toast';
import useSettings from '../../hooks/useSettings';
import ParametersContext from '../../contexts/ParametersContext';
import { THEMES } from '../../constants';
import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from './DashboardSidebar';
import Scrollbar from '../Scrollbar';
import useScrollReset from '../../hooks/useScrollReset';
import useAutoReloadOnUpdate from '../../hooks/useAutoReloadOnUpdate';

const DashboardLayoutRoot = experimentalStyled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  display: 'flex',
  height: '100%',
  overflow: 'hidden',
  width: '100%',
}));

const DashboardLayoutWrapper = experimentalStyled('div')(({ theme }) => ({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden',
  paddingTop: '14px', // era 64px change
  [theme.breakpoints.up('2000px')]: { paddingLeft: '280px' },
}));

/* Change
const DashboardLayoutWrapper = experimentalStyled('div')(({ theme }) => ({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden',
  paddingTop: '14px', // era 64px change
  [theme.breakpoints.up('lg')]: {
    paddingLeft: '280px'
  }
}));
*/

const DashboardLayoutContainer = experimentalStyled('div')({ display: 'flex', flex: '1 1 auto', overflow: 'hidden' });

const DashboardLayoutContent = experimentalStyled('div')({
  flex: '1 1 auto',
  height: '100%',
  overflow: 'auto',
  position: 'relative',
  WebkitOverflowScrolling: 'touch',
});

let toastShown = false;

// Ojo con scrollbar
function DashboardLayout() {
  const [isSidebarMobileOpen, setIsSidebarMobileOpen] = useState(false);
  const { settings } = useSettings();
  const { parametrosDB } = useContext(ParametersContext);
  const isDark = settings.theme === THEMES.OSCURO;

  useScrollReset();
  useAutoReloadOnUpdate();

  useEffect(() => {
    if (!parametrosDB) return;
    if (sessionStorage.getItem('appJustReloaded') && !toastShown) {
      toastShown = true;
      sessionStorage.removeItem('appJustReloaded');
      toast.success('La aplicación se actualizó a la última versión.', {
        id: 'app-update-toast',
        duration: 4000,
        style: isDark
          ? { background: '#222b36', color: '#e0e0e0', border: '1px solid #374151' }
          : { background: '#fff', color: '#121828', border: '1px solid #e0e0e0' },
        iconTheme: { primary: '#3f51b5', secondary: '#fff' },
      });
    }
  }, [parametrosDB]);

  return (
    <DashboardLayoutRoot>
      <DashboardNavbar onSidebarMobileOpen={() => setIsSidebarMobileOpen(true)} />
      <DashboardSidebar onMobileClose={() => setIsSidebarMobileOpen(false)} openMobile={isSidebarMobileOpen} />
      <DashboardLayoutWrapper>
        <DashboardLayoutContainer>
          <DashboardLayoutContent>
            <Scrollbar options={{ scrollYMarginOffset: 20 }}>
              <Outlet />
            </Scrollbar>
          </DashboardLayoutContent>
        </DashboardLayoutContainer>
      </DashboardLayoutWrapper>
    </DashboardLayoutRoot>
  );
}

export default DashboardLayout;
